<template>
  <div class="w-5 h-5 flex items-center justify-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
      <g clip-path="url(#clip0_4580_5584)">
        <path d="M10.1811 0H4.32036C1.93851 0 0.000732422 1.93778 0.000732422 4.31963V10.1804C0.000732422 12.5622 1.93851 14.5 4.32036 14.5H10.1811C12.563 14.5 14.5007 12.5622 14.5007 10.1804V4.31963C14.5007 1.93778 12.5629 0 10.1811 0ZM13.042 10.1804C13.042 11.7604 11.7611 13.0413 10.1811 13.0413H4.32036C2.74033 13.0413 1.45943 11.7604 1.45943 10.1804V4.31963C1.45943 2.73957 2.74033 1.4587 4.32036 1.4587H10.1811C11.7611 1.4587 13.042 2.73957 13.042 4.31963V10.1804Z" 
        fill="currentColor" />
        <path d="M7.2507 3.49976C5.18283 3.49976 3.50049 5.1821 3.50049 7.24994C3.50049 9.31779 5.18283 11.0002 7.2507 11.0002C9.31858 11.0002 11.0009 9.31782 11.0009 7.24994C11.0009 5.18207 9.31858 3.49976 7.2507 3.49976ZM7.2507 9.54149C5.98512 9.54149 4.95919 8.51555 4.95919 7.24997C4.95919 5.98439 5.98515 4.95846 7.2507 4.95846C8.51628 4.95846 9.54222 5.98439 9.54222 7.24997C9.54222 8.51552 8.51626 9.54149 7.2507 9.54149Z" 
        fill="currentColor" />
        <path d="M11.0081 4.42665C11.5044 4.42665 11.9068 4.02432 11.9068 3.52802C11.9068 3.03172 11.5044 2.62939 11.0081 2.62939C10.5118 2.62939 10.1095 3.03172 10.1095 3.52802C10.1095 4.02432 10.5118 4.42665 11.0081 4.42665Z" 
        fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_4580_5584">
          <rect width="14.5" height="14.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SpyderInstagramIcon'
}
</script>